import { render, staticRenderFns } from "./Sponsors.vue?vue&type=template&id=dcf8e414&scoped=true"
import script from "./Sponsors.vue?vue&type=script&lang=js"
export * from "./Sponsors.vue?vue&type=script&lang=js"
import style0 from "./Sponsors.vue?vue&type=style&index=0&id=dcf8e414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf8e414",
  null
  
)

export default component.exports